export function checkPrevAndTotal(idx, i, users) {
  const checkPrevTeeTimeString =
    idx >= 1 && i.teeTimeString !== users[idx - 1].teeTimeString;

  const checkPrevTeamName =
    idx >= 1 ? i.teamName !== users[idx - 1].teamName : i.teamName;

  const checkNextTeamName =
    idx >= 1 ? i.teamName !== users[idx + 1]?.teamName : i.teamName;

  const showTotal =
    idx >= 1 && users[0].teamName && i.teamName === users[idx].teamName;

  const hideTotalForOnePlayer =
    idx >= 1 && users[idx].teamName === users[idx - 1].teamName;

  return {
    checkPrevTeeTimeString,
    checkPrevTeamName,
    showTotal,
    checkNextTeamName,
    hideTotalForOnePlayer,
  };
}
